module.exports = __webpack_public_path__ + "media/dynamicmaschines.d9cc3aa8.mp4";